module.exports = __webpack_public_path__ + "static/img/100082.0325226f.png";